import React, { useContext, useEffect } from 'react'
import { Card, CardBody, IconButton, Checkbox, Spinner, Tooltip } from "@material-tailwind/react";
import { BiEdit, BiLink } from 'react-icons/bi';
import { IoEyeOutline } from 'react-icons/io5';
import { RiDeleteBinLine } from 'react-icons/ri';

import { Pagination, SearchAndAddBtn, Switch, THead } from '../../Components';
import { NewContext } from '../../Context/NewContext';
import { get_sliders_data } from '../../Controller/actions';
import SliderModal from '../../Components/Modals/SliderModal';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import Zoom from 'react-medium-image-zoom';
import { useLocation } from 'react-router-dom';

// const FilterDropdowns = ({ dropData = [] }) => {
//     return (
//         <div className='flex gap-4'>
//             <Dropdowns name={`Categories`} Icon={MdOutlineCategory} dropData={dropData} />
//         </div>
//     )
// }

export const Sliders = ({ title }) => {
    const { state } = useLocation();
    const { setDeleteUpdateTag, isLoading, confirmationModalShow, setConfirmationModalShow, deleteUpdateTag, setAddEditDeleteTag, setDeleteUpdateItem, setFormData, checkedValues, handleCheckboxChange, currentPage, totalPage, perPage, search, setDeleteUpdateYes, handleSwitchUpdate, handleCopyData, setIsLoading, setCurrentPage, setPerPage, setTotalPage, currentPageData, setCurrentPageData, filterDropdown, handleOpen, setFilterDropdown } = useContext(NewContext);
    const simpleFields = [
        { name: "Preview", },
        { name: "Name", sortable: true, field: 'name' },
        { name: "Country ", },
        { name: "Redirect To", sortable: true, field: 'theme_tagname' },
        { name: "Slider Tag", sortable: true, field: 'slider_tag' },
        { name: "Priority", },
    ];
    const dropdownFields = [{ name: "Premium", }, { name: "Active", }];
    const totalFields = simpleFields.length + dropdownFields.length + 2;

    const getSliderData = async (_currentPage = 1) => {
        setIsLoading(true);
        try {
            const getSliders = await get_sliders_data(_currentPage, perPage, search, filterDropdown);
            if (getSliders) {
                const { status, data, currentPage, perPage, totalPage } = getSliders;
                if (status) {
                    setCurrentPageData(data);
                    setCurrentPage(currentPage);
                    setPerPage(perPage);
                    setTotalPage(totalPage || 1);
                } else {
                    setCurrentPageData([]);
                }
            }
        } catch (error) {
            console.error(error);
        }
        setIsLoading(false);
    }

    useEffect(() => {
        getSliderData(currentPage);
        setDeleteUpdateTag("");
    }, [deleteUpdateTag, search, currentPage, perPage, filterDropdown]);

    useEffect(() => {
        document.title = title;
    }, [title]);

    return (
        <>
            <SearchAndAddBtn title={`Slider`} addBtn={true} deleteUpdateTag='all-delete-sliders' />
            <Card className="overflow-hidden w-full rounded-md shadow-none">
                <CardBody className="overflow-x-auto w-100 py-2.5 px-[5px] card-body-scrollbar">
                    <table className="w-full min-w-max table-auto text-left ">
                        <THead simpleFields={simpleFields} dropdownFields={dropdownFields} />
                        <tbody>
                            {
                                isLoading ?
                                    <tr>
                                        <td colSpan={totalFields} className='py-12'>
                                            <div className="flex justify-center items-center">
                                                <Spinner />
                                            </div>
                                        </td>
                                    </tr>
                                    : currentPageData?.length === 0 ?
                                        <tr>
                                            <td colSpan={totalFields} className='py-12 bg-gray-200'>
                                                <div className="flex justify-center items-center">
                                                    No Data Found
                                                </div>
                                            </td>
                                        </tr>
                                        : currentPageData?.map((_ele, i) => {
                                            const isLast = i === currentPageData?.length - 1;
                                            const classes = `text-[#1E1627] ${isLast ? "p-4" : "p-[14.5px]"}`;

                                            return (
                                                <tr key={i} className='border-b border-blue-gray-50'>
                                                    <td className={classes}>
                                                        <Checkbox
                                                            className='w-[18px] h-[18px] border-[1.5px] rounded-[3.6px] border-[#1E3354] checked:bg-[#0047FF] checked:border-transparent'
                                                            id={`slider-${_ele._id}`}
                                                            value={`${_ele._id}`}
                                                            checked={checkedValues.includes(`${_ele._id}`)}
                                                            onChange={() => handleCheckboxChange(`${_ele._id}`)}
                                                        />
                                                    </td>
                                                    <td className={`${classes}`}>
                                                        <div className='imgTd relative'>
                                                            <img src={_ele.preview_img || `../../../assets/images/no-image.png`} alt={_ele.name} className='mr-0 h-[55px] rounded-lg block absolute' />
                                                            <Zoom>
                                                                <img src={_ele.preview_img || `../../../assets/images/no-image.png`} alt={_ele.name} className='mr-0 h-[55px] rounded-lg block' />
                                                            </Zoom>
                                                        </div>
                                                    </td>
                                                    <td className={classes}>
                                                        <div className="flex items-center">
                                                            <span className={`font-normal text-[17px] ${!_ele.name && `text-gray-500`}`}>{_ele.name || `None`}</span>
                                                            {_ele.link && <button className='focus-visible:outline-none' onClick={() => handleCopyData(`Link`, _ele.link)}><BiLink className='text-[#2288FF] ml-2.5' size={20} /></button>}
                                                        </div>
                                                    </td>
                                                    {/* <td className={classes}>
                                                        <span className={`font-normal text-[17px] ${!_ele.region && `text-gray-500`}`}>{_ele.region || `None`}</span>
                                                        <span className={`font-normal text-[17px] ${_ele.category?.length == 0 && `text-gray-500`}`}>
                                                            {_ele.category && _ele.category?.length !== 0 ? _ele.category?.map((_ele, key) => key === _ele.category?.length - 1 ? _ele : `${_ele}, `) : `None`}
                                                        </span>
                                                    </td> */}
                                                    <td className={`${classes}`}>
                                                        <div className="flex items-center">
                                                            <p className={`font-normal !w-40 truncate p-0 text-[17px] ${!_ele.country?.length && `text-gray-500`}`}>
                                                                {_ele.country && _ele.country?.length !== 0 && _ele.country?.length > 1 ? _ele.country.map(_ele => _ele.name).slice(0, -1).join(", ") + ", " + _ele.country[_ele.country.length - 1].name : _ele.country && _ele.country?.length !== 0 && _ele.country[_ele.country.length - 1].name || `None`}
                                                            </p>
                                                            {
                                                                _ele.country && _ele.country?.length > 1 &&
                                                                <Tooltip placement="right-start" content={
                                                                    <div className="p-2 w-[300px] h-48 2xl:w-[400px] overflow-y-auto">
                                                                        {_ele.country && _ele.country?.length !== 0 && _ele.country?.length > 1 ? _ele.country.map(_ele => _ele.name).slice(0, -1).join(", ") + ", " + _ele.country[_ele.country.length - 1].name : _ele.country && _ele.country?.length !== 0 && _ele.country[_ele.country.length - 1].name || `None`}
                                                                    </div>
                                                                }>
                                                                    <InformationCircleIcon strokeWidth={2} className="text-[#1E1627] w-5 h-5 cursor-pointer" />
                                                                </Tooltip>
                                                            }
                                                        </div>
                                                    </td>
                                                    <td className={classes}>
                                                        <span className={`font-normal text-[17px] ${!_ele.theme_tagname && `text-gray-500`}`}>{_ele.theme_tagname || `None`}</span>
                                                    </td>
                                                    <td className={classes}>
                                                        <span className={`font-normal text-[17px] ${!_ele.slider_tag && `text-gray-500`}`}>{_ele.slider_tag || `None`}</span>
                                                    </td>
                                                    <td className={classes}>
                                                        <span className={`font-normal text-[17px] ${!_ele.priority && `text-gray-500`}`}>{_ele.priority || `None`}</span>
                                                    </td>
                                                    {
                                                        ["isPremium", "isActive"].map((_is_ele, i) => (
                                                            <td className={classes} key={i}>
                                                                {/* <Switch color="green" id={_ele._id} name={_is_ele} onChange={(e) => { setDeleteUpdateYes("update-slider"); handleSwitchUpdate(e) }} checked={_ele[_is_ele]} /> */}
                                                                <Switch id={_ele._id} name={_is_ele} onChange={(e) => { setDeleteUpdateYes("update-slider"); handleSwitchUpdate(e); }} checked={_ele[_is_ele]} />
                                                            </td>
                                                            // <td key={i}>
                                                            //     <Badge bg={_is_ele ? "success" : "danger"} className="fw-normal px-2">
                                                            //     {_is_ele ? `On` : `Off`}
                                                            // </Badge>
                                                            //     <Form.Check type="switch" id={_ele._id} name={_is_ele} onChange={handleSwitchUpdate} checked={_ele[_is_ele]} role="button" />
                                                            // </td>
                                                        ))
                                                    }
                                                    <td className={classes}>
                                                        <div className="flex items-center gap-2">
                                                            <IconButton className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none' onClick={() => { setDeleteUpdateYes("update-slider"); setAddEditDeleteTag(`update`); setFormData(_ele); handleOpen() }}>
                                                                <BiEdit />
                                                            </IconButton>
                                                            <IconButton className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none' onClick={() => { setAddEditDeleteTag(`view`); setFormData(_ele); handleOpen() }}>
                                                                <IoEyeOutline />
                                                            </IconButton>
                                                            <IconButton className='bg-[#EAEDF3] text-[#F62929] text-[21px] shadow-none hover:shadow-none' onClick={() => { setDeleteUpdateYes("delete-slider"); setDeleteUpdateItem({ id: _ele._id, name: _ele.name }); setConfirmationModalShow(!confirmationModalShow) }}>
                                                                <RiDeleteBinLine />
                                                            </IconButton>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                            }
                        </tbody>
                    </table>
                </CardBody>
            </Card>
            {
                totalPage > 1 &&
                <Pagination currentPage={currentPage} totalPage={totalPage} getData={getSliderData} />
            }
            <SliderModal />
        </>
    )
}

Sliders.defaultProps = {
    title: "My Photo Keyboard | Sliders"
};

export default Sliders
